import React from 'react';
import { pddRoot } from "../../../../utils/defaultValues";
import IntlMessages from "../../../../utils/IntlMessages";
import PddFullReportHome from './PddFullReportHome';

const FullReportRouteConfig = {
  routes: [
		{
    path: `${pddRoot}/project/full-report`,
    exact: true,
    name: <IntlMessages id={"menu.fullReport"}/>,
    element: <PddFullReportHome/>,
    auth: [],
  },
	]
};

export default FullReportRouteConfig;
